import React from 'react'
import photo from "../images/download.jpeg";

import { Link } from "react-router-dom";
import LysorichSyrup from "../images/Lysorich Syrup_2 NEW.jpg"
import LysorichGoldCapsules from "../images/Lysorich Gold Capsules NEW.jpg";
import ForteDrops from "../images/Kid CC-D3 Forte Drops.jpg";
import PicapDsrcapphoto from "../images/Picap Dsr cap NEW.jpg";
import AmypepSyrup from "../images/Amypep Syrup NEW.jpg";
import AmypepPlusSyrup from "../images/Amypep Plus Syrup NEW.jpg";
import KidCC_D3Drops from "../images/Kid CC-D3 Drops.jpg"
import MonticureLCTablets from "../images/Monticure LC Tablet.jpg";
import MonticureLCSyrup from "../images/Monticure LC Syrup.jpg";


function Ppage() {
  return (
    <div>
      <div className='back'>
        <div className="album py-2">
          <div className="container">
            <h1 style={{color:"#0d1a40"}} className='mt-3'><b>OUR PRODUCTS</b></h1>

          </div>
        </div>
 
        <div className="album py-0">
          <div className="container">
            <div className="row">
              <div className="col-md-3 mt-3">
                <div className="card" >
                  <img src={LysorichSyrup} className="card-img-top" alt="LysorichSyrup"/>
                  <div className="card-body">
                    <h5 style={{color:"#1F2064"}} className="card-title">Lysorich Syrup</h5>
                    <p className="card-text"><small>A health tonic enriched with essential Omega-3 fatty acids, multivitamins, and minerals to support overall growth, immunity, and cognitive development.</small></p>
                                                        <div className="d-flex justify-content-between align-items-center mb-0">
                    <a href='LysorichSyrup'>
                    <button  className="learnmore me-2">Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"/>
</svg></button></a>
                  <a href="tel: 8509330871" className="Callbook">Contact us </a>
                    </div>

                  </div>
                </div>
              </div>
              <div className="col-md-3 mt-3">

                <div className="card" >
                  <img src={LysorichGoldCapsules} className="card-img-top" alt="LysorichGoldCapsules"/>
                  <div className="card-body">
                    <h5 style={{color:"#1F2064"}} className="card-title">Lysorich Gold Capsules</h5>
                    <p className="card-text"><small>Premium nutraceutical softgel capsules fortified with Omega-3, vitamins, and antioxidants for adult wellness, heart health, and mental alertness.</small></p>
                                                      <div className="d-flex justify-content-between align-items-center mb-0">
                    <a href='LysorichGold'>
                    <button  className="learnmore me-2">Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"/>
</svg></button></a>
                    <a href="tel: 8509330871" className="Callbook">Contact us</a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-3 mt-3">

                <div className="card" >
                  <img src={KidCC_D3Drops} className="card-img-top" alt="KidCC_D3Drops"/>
                  <div className="card-body">
                    <h5 style={{color:"#1F2064"}} className="card-title">Kid CC-D3 Drops</h5>
                    <p className="card-text"><small>Specially formulated Vitamin D3 and Calcium supplement for infants and toddlers to support healthy bone development and immunity.</small></p>
                    <a href='Kidccd3'>
                    <button  className="learnmore me-2">Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"/>
</svg></button></a>
                    
               <a href="tel: 8509330871" className="Callbook">Contact us</a>
                  </div>
                </div>
              </div>
              <div className="col-md-3 mt-3">

                <div className="card" >
                  <img src={ForteDrops} className="card-img-top" alt="photo" />
                  <div className="card-body">
                    <h5 style={{color:"#1F2064"}} className="card-title">Kid CC-D3 Forte Drops</h5>
                    <p className="card-text"><small>An advanced version with higher potency Calcium + Vitamin D3, ideal for children with increased nutritional needs for bone strength and growth.</small></p>
                       <a href='Kidccd3forte'>
                    <button  className="learnmore me-2">Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"/>
</svg></button></a>
                    <a href="tel: 8509330871" className="Callbook">Contact us</a>
                  </div>
                </div>
              </div>
              <div className="col-md-3 mt-3">

                <div className="card" >
                  <img src={PicapDsrcapphoto} className="card-img-top" alt="PicapDsrcapphoto"/>
                  <div className="card-body">
                    <h5 style={{color:"#1F2064"}} className="card-title">Picap Dsr cap</h5>
                    <p className="card-text"><small>Specially formulated Vitamin D3 and Calcium supplement for infants and toddlers to support healthy bone development and immunity.</small></p>
                    <a href="tel: 8509330871" className="Callbook">Contact us</a>
                  </div>
                </div>
              </div>

              <div className="col-md-3 mt-3">

                <div className="card" >
                  <img src={AmypepSyrup} className="card-img-top" alt="AmypepSyrup"/>
                  <div className="card-body">
                    <h5 style={{color:"#1F2064"}} className="card-title">Amypep Syrup</h5>
                    <p className="card-text"><small>Digestive enzyme syrup for improving appetite and digestion, especially helpful in indigestion, bloating, and digestive enzyme deficiencies.</small></p>
                    <a href="tel: 8509330871" className="Callbook">Contact us</a>
                  </div>
                </div>
              </div>

              <div className="col-md-3 mt-3">

                <div className="card" >
                  <img src={AmypepPlusSyrup} className="card-img-top" alt="AmypepPlusSyrup"/>
                  <div className="card-body">
                    <h5 style={{color:"#1F2064"}} className="card-title">Amypep Plus Syrup</h5>
                    <p className="card-text"><small>A fortified digestive tonic with added herbal extracts and probiotics, promoting gut health and metabolic balance.</small></p>
                    <a href="tel: 8509330871" className="Callbook">Contact us</a>
                  </div>
                </div>
              </div>

              <div className="col-md-3 mt-3">

                <div className="card" >
                  <img src={MonticureLCTablets} className="card-img-top" alt="MonticureLCTablets" />
                  <div className="card-body">
                    <h5 style={{color:"#1F2064"}} className="card-title">Monticure LC Tablets</h5>
                    <p className="card-text"><small>Montelukast (10 mg) and Levocetirizine (5 mg).Used to relieve allergy symptoms like sneezing, runny nose, and breathing discomfort</small></p>
                    <a href="tel: 8509330871" className="Callbook">Contact us</a>
                  </div>
                </div>
              </div>

              <div className="col-md-3 mt-3">

                <div className="card" >
                  <img src={MonticureLCSyrup} className="card-img-top" alt="MonticureLCSyrup" />
                  <div className="card-body">
                    <h5 style={{color:"#1F2064"}} className="card-title">Monticure LC Syrup</h5>
                    <p className="card-text"><small>Monticure LC is a syrup that combines Levocetirizine and Montelukast as active ingredients.</small></p>
                    <a href="tel: 8509330871" className="Callbook">Contact us</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <br />
        <br />
      </div>
    </div>
  )
}

export default Ppage